function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.678 1.516a.5.5 0 00-.397.789L10.76 4.44A6.997 6.997 0 008.08 9h13.84a6.997 6.997 0 00-2.68-4.559l1.479-2.136a.5.5 0 00-.412-.79.5.5 0 00-.41.221l-1.49 2.157a6.944 6.944 0 00-6.813 0l-1.49-2.157a.5.5 0 00-.426-.22zM12 5a1 1 0 110 2 1 1 0 010-2zm6 0a1 1 0 110 2 1 1 0 010-2zM5 11a1 1 0 00-1 1v8a1 1 0 002 0v-8a1 1 0 00-1-1zm3 0v10a2 2 0 002 2v3.5a1.5 1.5 0 003 0V23h4v3.5a1.5 1.5 0 003 0V23a2 2 0 002-2V11H8zm17 0a1 1 0 00-1 1v8a1 1 0 002 0v-8a1 1 0 00-1-1z"
});

function SvgAndroid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    width: 30,
    height: 30
  }, props), _ref);
}

export default SvgAndroid;